import { Link } from "react-router-dom";
import { BookOpen, FileText, Award, ChevronRight } from "lucide-react";
import { Badge } from "@/components/ui/badge";

export function JournalCard({ journal, hideImpactFactor = false }) {
  return (
    <Link
      to={`/journal/${journal.slug}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={`journal-card-${journal.slug}`}
      className="group flex gap-4 bg-card rounded-xl border border-slate-200 dark:border-slate-800 p-4 hover:shadow-md hover:border-primary/30 hover:-translate-y-0.5 transition-all duration-200"
    >
      <div className="w-28 h-36 shrink-0 rounded-md overflow-hidden bg-slate-100 dark:bg-slate-800 flex items-center justify-center">
        {journal.cover_image
          ? <img src={journal.cover_image} alt={journal.title} className="w-full h-full object-contain" loading="lazy" />
          : <BookOpen className="w-6 h-6 text-slate-400" />}
      </div>
      <div className="min-w-0 flex-1">
        <h3 className="font-serif font-bold text-base leading-snug text-slate-900 dark:text-slate-100 group-hover:text-primary dark:group-hover:text-sky-300 transition-colors line-clamp-2">
          {journal.title}
        </h3>
        <p className="font-mono text-[11px] text-slate-400 mt-1">ISSN {journal.issn}</p>
        <div className="flex items-center gap-2 mt-2 flex-wrap">
          {journal.impact_factor && !hideImpactFactor && (
            <Badge variant="outline" className="text-[11px] gap-1 bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-800">
              <Award className="w-3 h-3" /> IF {journal.impact_factor}
            </Badge>
          )}
          <span className="inline-flex items-center gap-1 text-xs text-slate-500">
            <FileText className="w-3.5 h-3.5" /> {journal.paper_count ?? 0} articles
          </span>
        </div>
        <span className="mt-2 inline-flex items-center gap-0.5 text-xs font-medium text-primary dark:text-sky-400 group-hover:gap-1.5 transition-all">
          View journal <ChevronRight className="w-3.5 h-3.5" />
        </span>
      </div>
    </Link>
  );
}
